/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import {
  Form,
  // Row,
  Col,
  Input,
} from 'antd';
// import Mapa from 'components/Mapa';
import address from 'utils/address';
import { getPlantillaIndexada } from 'api/tramites/plantillasDeTramites';
import { getTramite } from 'api/tramites/tramites';

export const estadosCitasMap = {
  PROGRAMADA: 1,
  EN_PROCESO: 2,
  NO_ASISTIO: 3,
  FINALIZADA: 4,
  CANCELADA: 5,
};

export const estadosDeCitas = [
  {
    id: 1,
    descripcion: 'Programada',
  },
  {
    id: 2,
    descripcion: 'En proceso',
  },
  {
    id: 3,
    descripcion: 'No asistió',
  },
  {
    id: 4,
    descripcion: 'Finalizada',
  },
  {
    id: 5,
    descripcion: 'Cancelada',
  },
];

export const fillValuesCita = async (cita, formInstance, plantilla) => {
  const plantillaIndex = plantilla || await getPlantillaIndexada(cita.plantilla_de_tramite);
  const oficina = plantillaIndex.centro_de_costos.find((e) => e.id === cita.oficina);
  const values = {
    folio: cita.folio,
    tramite: plantillaIndex.nombre,
    fecha: cita.horario_inicio.format(),
    horario: `${cita.horario_inicio.format('hh:mm a')} - ${cita.horario_fin.format('hh:mm a')}`,
    estado_de_cita: estadosDeCitas.find((e) => e.id === cita.estado_de_cita)?.descripcion,
    direccion: address(oficina.direccion),
    oficina: oficina.descripcion,
    folio_tramite: 'N/A',
  };
  const tramite = cita.tramite ? await getTramite(cita.tramite) : null;
  if (tramite) {
    values.folio_tramite = tramite?.folio;
  } else if (plantillaIndex.permite_iniciar_tramite_con_cita) {
    values.folio_tramite = 'Por definir';
  }
  if (formInstance) {
    setTimeout(() => formInstance.setFieldsValue(values));
  }
  return values;
};

const ConsultaCita = ({ cita, autoFill = true }) => {
  const formInstance = Form.useFormInstance();

  // const getCoords = (o) => (o?.direccion?.longitud && o?.direccion?.latitud
  //   ? [o.direccion.longitud, o.direccion.latitud] : []);

  useEffect(() => {
    if (autoFill) {
      fillValuesCita(cita, formInstance);
    }
  }, []);

  return (
    <>
      <Col xs={24} sm={24} md={12} order={1}>
        <Form.Item label="Folio" name="folio" labelCol={{ span: 6 }}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} order={2}>
        <Form.Item label="Estado" name="estado_de_cita" labelCol={{ span: 6 }}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} order={3}>
        <Form.Item label="Horario" name="horario" labelCol={{ span: 6 }}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} order={4}>
        <Form.Item label="Fecha" name="fecha" labelCol={{ span: 6 }}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col span={24} order={8}>
        <Form.Item label="Trámite" name="tramite" labelCol={{ span: 3 }}>
          <Input disabled />
        </Form.Item>
      </Col>
      <Col span={24} order={9}>
        <Form.Item label="Dirección" name="direccion" labelCol={{ span: 3 }}>
          <Input disabled />
        </Form.Item>
      </Col>
      {/* <Col span={24}>
        <Form.Item label="Ubicacion" labelCol={{ span: 3 }} />
        <Row>
          <Col xs={0} sm={0} md={3} />
          <Col xs={24} sm={24} md={21} style={{ marginTop: -60 }}>
            <Mapa
              form={formInstance}
              interactive={false}
              coords={getCoords()}
              height={240}
              withLatLngInputs={false}
            />
          </Col>
        </Row>
      </Col> */}
    </>
  );
};

export default ConsultaCita;
